import { getAddableFileProviderInfo, } from '../utils/AddableFileProviderInfo';
import datapoints from '../datapoints';
import { action } from 'satcheljs/lib/legacy';
import { clearAuthWindowInfo, setAuthWindowInfo } from './helpers/AuthWindowInfo';
import { logUsage } from 'owa-analytics';
function openDialogWindowInCenter(url, width, height) {
    var left = (window.screen.width - width) / 2;
    var top = (window.screen.height - height) / 2;
    var features = "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left + ", menubar=no, toolbar=no";
    return window.open(url, '_blank', features);
}
export default action('addFileProvider')(function addFileProvider(providerType, getAddableFileProviderInfoCustom, updateProvider) {
    var _a = datapoints.FPAddDataProviderAuthWindowOpened.datapoint, eventName = _a.name, customData = _a.customData;
    logUsage(eventName, customData(providerType));
    return new Promise(function (resolve, reject) {
        getAddableFileProviderInfoCustom =
            getAddableFileProviderInfoCustom || getAddableFileProviderInfo;
        var addableFileProviderInfo = getAddableFileProviderInfoCustom(providerType);
        var _a = addableFileProviderInfo.getAuthUrlInfo(), authUrl = _a.authUrl, redirectUrl = _a.redirectUrl, csrfToken = _a.csrfToken;
        var authWindowInfo = {
            info: {
                redirectUrl: redirectUrl,
                csrfToken: csrfToken,
                updateProvider: updateProvider,
            },
            onProviderAdded: function (provider) { return resolve(provider); },
            onErrorAddingProvider: function (error) { return reject(error); },
            getAddableFileProviderInfo: getAddableFileProviderInfoCustom,
        };
        // Remove any previous auth info and then set the new auth window info
        clearAuthWindowInfo(providerType);
        setAuthWindowInfo(providerType, authWindowInfo);
        openDialogWindowInCenter(authUrl, 600, 600);
    });
});
//# sourceMappingURL=addFileProvider.js.map